<footer>
    <div class="content">
        <div class="footerleft">
            <a routerLink="/" fragment="hero"><img class="logo" src="assets/images/Logo farbig_transparent 3D.png" alt=""></a>

        </div>
        <div class="footer-imp-mb">
            <a routerLink="/imprint" class="implink">{{text.imprint}}</a>
        </div>
        <div class="footercenter">
            <a routerLink="/imprint" class="implink">{{text.imprint}}</a>
            &nbsp;|&nbsp; &copy; Irina Gorges 2025

        </div>

        <div class="footerright">
            <a href="https://github.com/Irina-Gorges/" target="_blank"> <img src="assets/icons/Github button.png" alt=""
                    class="sm-img"></a>
            <a href="mailto:irinagorges@live.de"> <img src="assets/icons/Email button.png" alt="" class="sm-img"></a>
            <a href="https://www.linkedin.com/in/irina-g-656486340/" target="_blank"> <img
                    src="assets/icons/Linkedin button.png" alt="" class="sm-img"></a>
        </div>

    </div>
</footer>